declare var swal: any;
import { Component, OnInit } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../models/appdata';
import { IsSessionExistsRequest } from '../../models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { ApiResponseModel } from '../../models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../services/hcp.service';
import { SpinnerService } from '../../services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';





@Component({
  selector: 'schedular',
  templateUrl: './schedular.component.html',
  styleUrls: [
    './Schedular.component.scss']
  ,animations: [routerTransition()]
})

export class SchedularComponent implements OnInit {
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }
   
  public ActorCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public isRequesting: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;

  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;


  sub: Subscription;
  ngOnInit() {

    this.CurrentActorDashBoardProfileSummaryInfoRequest = new ActorDashBoardProfileSummaryInfoRequest();
    this.CurrentDashBoardProfileSummaryController = new DashBoardProfileSummaryController();
   
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.isNew = true;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDashBoardProfileSummaryController();

   
  }

  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loginservice: LoginService) { }

  ShowList: boolean = true;

  GetDashBoardProfileSummaryController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.hcpservice.GetDashBoardProfileSummaryController(this.CurrentActorDashBoardProfileSummaryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('GetActorProfileController');
          this.CurrentDashBoardProfileSummaryController = this.ApiResData.Result[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }
  //openScheduleAssistant() {
  //  //alert("...");
  //  const modalRef = this.modalService.open(NgbScheduleAssistantModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })
  //  modalRef.componentInstance.ActorCode = this.ActorCode;
  //  modalRef.result.then(x => { this.GetActorIdentitiesController() })

  //}
  CancelNewOperation() {
    
    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

 
  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }
  gotoviewprofile() {
    //alert(this.gotoviewprofile);
    this.router.navigate(['testnurse/profileview']);
  }
    
  


 

}
